function loadGameWithScript(optionParams) {
	const token = optionParams.token;
	const gameContainer = document.getElementById('gameloader');

	const options = {
		operator: optionParams.operator,
		language: optionParams.language,
		environment: optionParams.environment,
		currency: optionParams.currency,
		game: optionParams.game,
		device: 'mobile',
		target: gameContainer
	};

	gameContainer.setAttribute('style', 'display:block;background: #000;position: absolute;top: 0;right: 0;left: 0;bottom: 0;z-index: 100000;');

	if (!(!token || token.length === 0)) {
		options.token = token;
	}

	const api = nolimit.load(options);

	api.on('exit', () => {
		history.back();
	});
}

function load(params) {
	let script = document.getElementById('nolimit');
	if (script === null) {
		script = document.createElement('script');
		script.src = '//nolimitcity.github.io/nolimit.js/dist/nolimit-latest.min.js';
		script.id = 'nolimit';
		document.getElementsByTagName('head')[0].appendChild(script);
		if (script.readyState) {
			script.onreadystatechange = () => {
				if (script.readyState === 'loaded' ||
					script.readyState === 'complete') {
					script.onreadystatechange = null;
					loadGameWithScript(params);
				}
			};
		} else {
			script.onload = () => {
				loadGameWithScript(params);
			};
		}
	} else {
		loadGameWithScript(params);
	}
}

export default { load };



// WEBPACK FOOTER //
// ./mobile-core/src/casino/providers/nolimit.js